var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DialogConfirmation',{attrs:{"show-modal":_vm.columnToDelete !== null,"confirm-class":"error","title":_vm.t('tables', 'Delete column'),"description":_vm.deleteDescription},on:{"confirm":_vm.deleteColumn,"cancel":function($event){return _vm.$emit('cancel')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }